<template>
    <BasicDialog @close="closeClicked" class="paypal-dialog">
        <div>
            <div class="d-flex flex-column flex-sm-row justify-sm-space-between">


                <v-icon class="paypal-dialog__logo mt-1 mt-md-4 mb-5 mb-md-6">
                    <paypal-big-icon></paypal-big-icon>
                </v-icon>

                <div class="d-flex flex-column paypal-dialog__amount">
                    <span class="paypal-dialog__amount-label">
                        Withdrawal amount
                    </span>

                    <span class="paypal-dialog__amount-value">
                        {{ selectedDenomination?.currency }} {{ selectedDenomination?.currency_amount }}
                    </span>
                </div>
            </div>
            <v-divider class="divider"></v-divider>
            <v-form @submit.prevent="paypalConfirmWithdrawalClicked" ref="formRef" class="paypal-dialog__form">
                <div class="d-flex flex-column align-center">
                    <div class="paypal-dialog__title mb-2">Fill your PayPal information</div>
                    <div class="paypal-dialog__subtitle">
                        You need to fill your PayPal email address to receive your rewards.
                    </div>
                </div>
                <CustomInput label="Email Address" placeholder="johndoe@example.com" v-model="form.paypalEmail"
                    :error-messages="v$.paypalEmail.$errors.map(e => e.$message)" @blur="v$.paypalEmail.$touch()"
                    type="email" required />
                <button :loading="submittingPaypalEmail" type="submit"
                    class="paypal-dialog__submit-btn rounded-pill px-10 py-4 d-flex button--primary">
                    Confirm Withdraw
                </button>
            </v-form>
        </div>
    </BasicDialog>
</template>



<script setup>

import { useVuelidate } from '@vuelidate/core';
import { useUserStore } from '@/store/UserStore';
import { useSnackbar } from '@/composables/useSnackbar';
import PaypalBigIcon from '@/icons/PaypalBig.vue';
import { PayoutStore } from '@/store/PayoutStore';
import CustomInput from '@/components/Common/CustomInput.vue';
import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import { paypalWithdrawInformationRules } from '@/utils/ValidationRules';
import { computed, ref, provide, inject, reactive } from 'vue';

const emit = defineEmits(['close', 'confirmWithdrawalClicked']);

let openDialog = ref(true);
openDialog = inject('paypalWithdrawalInformationDialogOpen');
provide('openDialog', openDialog);


const form = reactive({
    paypalEmail: ''
});
const v$ = useVuelidate(paypalWithdrawInformationRules, form);


const { showSnackbar } = useSnackbar();
const userStore = useUserStore();
const payoutStore = PayoutStore();
const submittingPaypalEmail = ref(false);


const paypalConfirmWithdrawalClicked = async () => {
    v$.value.$touch();
    if (v$.value.$invalid) {
        showSnackbar({
            message: 'Please enter a valid PayPal email address.',
            color: 'error'
        });
        return;
    }

    try {
        submittingPaypalEmail.value = true;
        userStore.setPaypalEmail(form.paypalEmail);
        await userStore.updateUserPaypalEmail();
        openDialog.value = false;
        showSnackbar({
            message: 'Paypal email updated successfully',
            color: 'success'
        });
    }
    finally {
        submittingPaypalEmail.value = false;
    }
    emit("confirmWithdrawalClicked");
};


const selectedDenomination = computed(() => {
    return payoutStore.SelectedDenomination || {};
});

const closeClicked = () => {
    emit("close");
};


</script>